import React from 'react';
import { ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";

const LikeFooterLoader = () => {
  return (
    <>
      <div className="d-flex align-items-center pd-x-20 h-100 justify-content-center">
          <div className="d-flex flex-grow-1 align-items-center">
            <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
            <div style={{ width: '48px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0" /></div>
          </div>
          <div style={{ width: '75px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0" /></div>
        </div>
    </>
  );
};

export default LikeFooterLoader;
